import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Box, Typography } from '@mui/material';
import { constantsStore } from '@ai/common/src/store/ConstantsStore';
import { AuthYandex } from './AuthYandex';
import { AuthVK } from '@pages/login/AuthVK.tsx';
import { Language } from '@ai/common/src/types/language';
import { IUser } from '@ai/common/src/types/user';

export const LoginWith = observer(
  ({ navigateAfterLogin }: { navigateAfterLogin: (user: IUser, balance: boolean) => void }) => {
    const { i18n, t } = useTranslation();

    useEffect(() => {
      if (!constantsStore.authConstants) {
        constantsStore.initAuthConstants();
      }
    }, []);

    if (!constantsStore.authConstants) {
      return null;
    }

    return (
      <Box sx={{ gap: 2, flexDirection: 'column', display: 'flex' }} mt={1}>
        <Box
          sx={{
            flexDirection: 'row',
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
          ml={5}
          mr={5}
          mb={1}
        >
          <Box
            style={{
              height: '1px',
              border: 'none',
              backgroundColor: '#C0C3CA',
              display: 'flex',
              flexGrow: 1,
            }}
          />
          <Typography variant="body2" color="text.secondary">
            {t('login.or')}
          </Typography>

          <Box
            style={{
              height: '1px',
              border: 'none',
              backgroundColor: '#C0C3CA',
              display: 'flex',
              flexGrow: 1,
            }}
          />
        </Box>

        <AuthYandex navigateAfterLogin={navigateAfterLogin} />

        <AuthVK lang={i18n.language as Language} navigateAfterLogin={navigateAfterLogin} />
      </Box>
    );
  }
);
